module.exports = __webpack_public_path__ + "img/lb6.ad4bf6d8.jpg";